import { applyMiddleware, createStore as originalCreateStore, Middleware, Store } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import sagaMiddlewareFactory from 'redux-saga';

import { UpgradeModalState } from './types';
import { ActionTypes } from './actions';
import { GdsServicesCalculatedLimitInfo } from '../../../types';
import { upgradeModalReducer } from './reducers';
import { Baggage } from '../../../BaggageService/types';
import { detectDifferentForReturnFlight, getSelectedServicesWithConfirmedCount } from '../utils';
import { SelectedUpgrade } from '../types';
import { Segment, Passenger } from '../../types';
import memes from '../../../memes';
import rootSaga from './sagas';
import { Config } from '../../../context';

export const createStore = memes(
	(
		services: Baggage[],
		segments: Segment[],
		passengers: Passenger[],
		selectedServices: SelectedUpgrade[],
		baggageTab: string,
		config: Config,
		initialBaggageTab?: string,
		disabled: boolean = false,
		upgradableBaggage: Baggage[] = [],
		gdsServicesCalculatedLimitInfo: GdsServicesCalculatedLimitInfo = {}
	): Store<UpgradeModalState, ActionTypes> => {
		const saga = sagaMiddlewareFactory({
			context: {
				config,
				upgradableBaggage
			}
		});

		const middleware: Middleware[] = [saga];

		if (process.env.NODE_ENV === 'development') {
			middleware.push(require('redux-logger').default);
		}

		const store = originalCreateStore<UpgradeModalState, ActionTypes, {}, {}>(
			enableBatching(upgradeModalReducer as any),
			{
				services,
				upgradableBaggage,
				selectedServices: getSelectedServicesWithConfirmedCount(selectedServices, passengers),
				differentForReturnFlight: detectDifferentForReturnFlight(segments, selectedServices),
				disabled,
				baggageTab,
				initialBaggageTab,
				currentSlide: 0,
				passengers,
				segmentIds: segments.map(segment => segment.id),
				gdsServicesCalculatedLimitInfo
			},
			applyMiddleware(...middleware)
		);

		saga.run(rootSaga);

		return store;
	}
);
